module.exports = __webpack_public_path__ + "img/hochvogel.5be546fe.jpg";